import {
    Text,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
    Stack,
    Radio,
    RadioGroup,
    Button
  } from '@chakra-ui/react';



function ThresholdBuilder( { tempWidget, setTempWidget}) {
    

  
    const handleChange = (valueString, type, tier) => {
        
        let updatedWidgetObject = {...tempWidget};
        let newThresholds = {...tempWidget.thresholds};
        
        let newThresholdObject={...newThresholds[tier]};

        if(type === 'value') {
            newThresholdObject.value = valueString;
        } else if (type === 'operand') {
            newThresholdObject.operand = valueString;
        }

        newThresholds[tier] = newThresholdObject;
        updatedWidgetObject.thresholds = newThresholds;
        setTempWidget(updatedWidgetObject);
    };
    
    const handleClear = () => {
        let updatedWidgetObject = {...tempWidget};
        updatedWidgetObject.thresholds = {};
        setTempWidget(updatedWidgetObject);
    };

    return (
      
      <div>
        <Text as='b'>Set First Tier</Text>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'start', marginBottom: '5%'}}>
            <RadioGroup onChange={(valueString) => handleChange(valueString, 'operand', 'first')} value={tempWidget.thresholds?.first?.operand || 0}>
                <Stack direction='row' spacing={8}>
                    <Radio value='>'>Greater Than</Radio>
                    <Radio value='<'>Less Than</Radio>
                    <NumberInput
                      width='25%'
                      value={tempWidget.thresholds.first?.value || ''}
                      onChange={(valueString) => handleChange(valueString, 'value', 'first')}
                    >
                      <NumberInputField />
                      <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                </Stack>
            </RadioGroup>
        </div>
        <Text as='b' >Set Second Tier</Text>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'start', marginBottom: '5%'}}>
            <RadioGroup onChange={(valueString) => handleChange(valueString, 'operand', 'second')} value={tempWidget.thresholds.second?.operand || 0}>
                <Stack direction='row' spacing={8}>
                    <Radio value='>'>Greater Than</Radio>
                    <Radio value='<'>Less Than</Radio>
                    <NumberInput
                      width='25%'
                      value={tempWidget.thresholds.second?.value || ''}
                      onChange={(valueString) => handleChange(valueString, 'value', 'second')}
                    
                    >
                      <NumberInputField />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                </Stack>
            </RadioGroup>
        </div>
        <Button onClick={handleClear}>Clear Thresholds</Button>
      </div>
    );
  }

  export default ThresholdBuilder;